import React from "react";
import { useFormik } from "formik";
import axios from "axios";

const Register = () => {
    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
            confirmPassword: ""
        },
        validate: values => {
            const errors = {};
            if (!values.email) {
                errors.email = "Required";
            } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
                errors.email = "Invalid email address";
            }

            if (!values.password) {
                errors.password = "Required";
            } else if (values.password.length < 6) {
                errors.password = "Password must be at least 6 characters";
            }

            if (!values.confirmPassword) {
                errors.confirmPassword = "Required";
            } else if (values.password !== values.confirmPassword) {
                errors.confirmPassword = "Passwords do not match";
            }

            return errors;
        },
        onSubmit: async values => {
            try {
                const response = await axios.post(
                    "https://manncarriers.com/server/register.php",
                    // "http://localhost:8080/mann/register.php",
                    {
                        email: values.email,
                        password: values.password
                    },
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                );
                
                console.log("Response:", response.data);
                alert("Registration successful!");
            } catch (error) {
                console.error("Registration failed:", error);
                alert("Something went wrong.");
            }
        }
    });

    return (
        <>
            <div id="hero" className="Starter section dark-background">
                <img src="assets/img/image2.jpg" alt="Mann Carriers truck poised to lead global logistics with strength and ambition" data-aos="fade-in" />
            </div>
            <div className="containerLog">
                <div className="LogInBox" data-aos="fade-up" data-aos-delay="200">
                    <h1 className="mb-4 text-uppercase fw-bolder">Register</h1>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="mb-4">
                            <label className="block font-semibold">Email</label>
                            <div className="inputBox">
                                <input
                                    className="p-2 form-control"
                                    type="email"
                                    name="email"
                                    onChange={formik.handleChange}
                                    value={formik.values.email}
                                />
                                {formik.errors.email && (
                                    <div className="text-red-500 text-sm">{formik.errors.email}</div>
                                )}
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="block font-semibold">Password</label>
                            <div className="inputBox">
                                <input
                                    className="p-2 form-control"
                                    type="password"
                                    name="password"
                                    onChange={formik.handleChange}
                                    value={formik.values.password}
                                />
                                {formik.errors.password && (
                                    <div className="text-red-500 text-sm">{formik.errors.password}</div>
                                )}
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="block font-semibold">Confirm Password</label>
                            <div className="inputBox">

                                <input
                                    className="p-2 form-control"
                                    type="password"
                                    name="confirmPassword"
                                    onChange={formik.handleChange}
                                    value={formik.values.confirmPassword}
                                />
                                {formik.errors.confirmPassword && (
                                    <div className="text-red-500 text-sm">{formik.errors.confirmPassword}</div>
                                )}
                            </div>
                        </div>

                        <button type="submit" className="logButton mt-4" >
                            Register
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default Register;
